<template>
<div>
  <devices-list-filters :owners-options="ownersOptions" :contracts-options="contractsOptions"
                        :categories-options="categoriesOptions" :types-options="typesOptions" :groups-options="groupsOptions"
                        :type-filter.sync="typeFilter" :categories-filter.sync="categoriesFilter"
                        :owners-filter.sync="ownersFilter" :contracts-filter.sync="contractsFilter" :group-filter.sync="groupFilter">
  </devices-list-filters>
  <b-form class="p-2" @submit.prevent="submit">

    <b-form-group :label="$t('Select Device')"
                  label-for="device" :state="null">

      <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          v-model="request.device"
          :options="devicesOptions"
          class="w-100"
          :reduce="d => d.id"
          label="name"
      />

      <b-form-invalid-feedback v-if="errors && ('device' in errors)" :state="errors && ('device' in errors) ? false : null">
        {{errors['device'][0] }}
      </b-form-invalid-feedback>

    </b-form-group>


    <!--        <b-form-group :label="$t('Show Geofence for this device')"-->
    <!--                      label-for="device" :state="null">-->

    <!--         <b-form-checkbox-->
    <!--             v-model="geoFilter">-->
    <!--           {{ $t('only geofences associated with this device') }}-->
    <!--         </b-form-checkbox>-->

    <!--        </b-form-group>-->



    <b-form-group :label="$t('From Date')" :state="null">

      <flat-pickr v-model="request.from" class="form-control"
                  :config="{...pickerOptions, defaultHour: 0, defaultMinute:0}"
                  placeholder="YYYY-MM-DD"
      />

      <b-form-invalid-feedback v-if="errors && ('from' in errors)" :state="errors && ('from' in errors) ? false : null">
        {{errors['from'][0] }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group :label="$t('To Date')" :state="null">
      <flat-pickr v-model="request.to" class="form-control"
                  :config="{ ...pickerOptions, defaultHour: 23, defaultMinute: 59}"
                  placeholder="YYYY-MM-DD"
      />

      <b-form-invalid-feedback v-if="errors && ('to' in errors)" :state="errors && ('to' in errors) ? false : null">
        {{errors['to'][0] }}
      </b-form-invalid-feedback>
    </b-form-group>

    <!-- Form Actions -->
    <div class="d-flex mt-2">
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-2"
          type="submit">
        {{ $t('History Data') }}
      </b-button>
    </div>
  </b-form>
</div>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BTable, BPagination, BRow, BCol, BFormCheckbox
} from 'bootstrap-vue'
import { computed, ref, watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'
import DevicesListFilters from '@/views/modules/device/devices-list/DevicesListFilters'
import Table from '@/views/table/bs-table/Table'
import filters from '@/views/modules/Utils/filters'

export default {
  components: {
    Table,
    DevicesListFilters,

    BSidebar,
    BForm,BFormCheckbox,
    BTable,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BPagination,
    vSelect,
    OrbitSpinner,

    flatPickr,
    BRow,
    BCol

  },
  directives: {
    Ripple,
  },

  setup() {

    const pickerOptions = {
      dateFormat: 'Y-m-d H:i:S',
      enableTime: true,
      enableSeconds: true,
      mode: 'single',
      time_24hr: true,
      onChange: function(rawdate, altdate, FPOBJ) {
        FPOBJ.close()
        FPOBJ._input.blur()
      }
    }

    const categoriesFilter = ref([])
    const ownersFilter = ref([])
    const typeFilter = ref(null)
    const groupFilter = ref(null)
    const contractsFilter = ref([])

    const sidebarLoader = ref(false)

    const filter = ref({})

    const isActive = computed(() => store.state.h_map_store.historySideBar)

    const { ownersOptions, groupsOptions, contractsOptions,
      categoriesOptions, typesOptions } = filters('device')

    const errors = ref({})
    const devicesOptions = ref([])

    const request = ref({
      device: null,
      from: null,
      to: null
    })


    watch([categoriesFilter, ownersFilter, typeFilter, groupFilter, contractsFilter], () => {

      filter.value = {
        ...(groupFilter.value && { group: groupFilter.value}),
        ...(ownersFilter.value && {owners: ownersFilter.value}),
        ...(typeFilter.value && {typee: typeFilter.value}),
        ...(contractsFilter.value && {contracts: contractsFilter.value}),
        ...(categoriesFilter.value && {categories: categoriesFilter.value})
      }

      fetchDevicesOptions()

    })


    const fetchDevicesOptions = () => {
      sidebarLoader.value = true
      store.dispatch('h_map_store/getDevicesOptions', {
        type: 'device',
        user: store.state.auth.userData.id,
        ...filter.value
      }).then(res =>  devicesOptions.value = res.data).catch(reason => {})
          .finally(() => sidebarLoader.value = false)
    }


    fetchDevicesOptions()

    const submit = () => {
      errors.value = {}
      store.dispatch('h_map_store/getHistory', request.value).then(res=> {}).catch(reason => {
        if (reason.status === 422) { errors.value = reason.data.errors}
      })
    }

    const toggleSideBar = v => {
     store.commit('h_map_store/TOGGLE_SIDEBAR', v)
    }

    return {
      ownersOptions, groupsOptions, contractsOptions, categoriesOptions, typesOptions,
      categoriesFilter, ownersFilter, typeFilter, groupFilter, contractsFilter,
      toggleSideBar,
      pickerOptions,
      submit,

      isActive,
      request,
      devicesOptions,
      errors,sidebarLoader
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
